import { StorageStepSchema } from '@feedyou-ai/feedbot-schema'
import { Mutable, SelectedMutations, updateMutation } from '@feedyou/utils'

import { Action, actionTypes } from './actions'

export function storageReducer(
  step: Mutable<StorageStepSchema>,
  action: Action,
  selectedMutations: SelectedMutations
) {
  switch (action.type) {
    case actionTypes.SET_STORAGE:
      return {
        ...step,
        storage: selectedMutations
          ? updateMutation(step, step.type, action.storage, selectedMutations)
          : action.storage
      }

    default:
      return step
  }
}
